import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const PriceUpdateNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show the modal after a short delay for better UX
    const timer = setTimeout(() => {
      setShow(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShow(false);
    // Remember that user dismissed i
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#d80009", color: "white" }}
      >
        <Modal.Title>
          <strong>Booking Policy</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "2rem", fontSize: "1.1rem" }}>
        <p className="mb-0">
          Bookings of more than 5 employees reserve capacity. Cancel at least 24
          hours in advance to avoid charges. Late cancellations, reductions, or
          no-shows will be charged in full.{" "}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          I Understand
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PriceUpdateNotice;
